// extracted by mini-css-extract-plugin
module.exports = {"flex_row":"Metrics_flex_row__Q_9xc","flex_column":"Metrics_flex_column__3SwCB","metrics":"Metrics_metrics__3zQuu"};